import * as ReselectModule from "reselect";
import { IClientDocumentListState } from ".";
import { IApplicationState } from "..";

export const selectClientDocumentList: ReselectModule.Selector<
  IApplicationState,
  IClientDocumentListState
> = (state) => state.clientDocumentList;
